import { IconProps } from "models"
import { ICON_DEFAULT_SIZE } from "utils/constants"

const RightArrowIcon: React.FC<IconProps> = ({
	className = "",
	style = null,
	color = "currentColor",
	size = ICON_DEFAULT_SIZE,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			className={className}
			style={style}
			aria-hidden="true"
		>
			<path
				fill={color}
				d="m22.414 10.586-7-7a2 2 0 0 0-2.828 2.828L16.172 10H3a2 2 0 0 0 0 4h13.172l-3.586 3.586a2 2 0 1 0 2.828 2.828l7-7a2 2 0 0 0 0-2.828z"
			/>
		</svg>
	)
}

export default RightArrowIcon
